import React from "react";
import CV from "../My_Resume.pdf";

function Resume() {
  return (
    <section id="resume" className="resume">
      <div className="container">
        <div className="section-title">
          <h2>Resume</h2>
          <div className="row">
            <p className="col-md-8 ">Check My Resume</p>
            <div className="col-md-4 d-flex justify-content-md-end cv-btn ">
              <a href={CV} download="Awshad_CV.pdf">
                <button className="btn btn-primary">Download CV</button>
              </a>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <h3 className="resume-title">Sumary</h3>
            <div className="resume-item pb-0">
              <h4>Mohamed Awshad</h4>
              <p className="text-justify">
                <em>
                  Innovative and highly motivated web developer with 3+ years of
                  experience in web designing and developing responsive websites
                  from initial concept to final, polished deliverable.
                </em>
              </p>
              <p>
                <ul>
                  <li>42. S.H Road, Meerakerny, Eravur.</li>
                  <li>+94756800099</li>
                  <li>mawsa3454@gmail.com</li>
                </ul>
              </p>
            </div>

            <h3 className="resume-title">Education</h3>
            <div className="resume-item">
              <h4>BEng(Hons) in Software Engineering</h4>
              <h5>2020 - 2021</h5>
              <p>
                <em>London Metropoliton University, UK</em>
              </p>
              <p>
                I have completed my bachelor's degree in Software Engineering in
                London Metropoliton University from 2020 to 2021
              </p>
            </div>
            <div className="resume-item">
              <h4>Higher National Diploma in Computing</h4>
              <h5>2018 - 2020</h5>
              <p>
                <em>ESoft Metro Campus, Batticaloa, Sri Lanka</em>
              </p>
              <p>
                I have completed my Higher National Diploma in Computing in
                ESoft Metro Campus Batticaloa from 2018 to 2020
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <h3 className="resume-title">Professional Experience</h3>
            {/* <div className="resume-item">
                            <h4>Software Engineer (React and .Net Core)</h4>
                            <h5>2022 - Present</h5>
                            <p><em>Fintechnology Asia Pacific (FINAP)</em></p>
                            <p>
                                <ul>
                                    <li>Implemented website interfaces using React.</li>
                                    <li>Using .Net Core as backend language and MSSQL as Database.</li>
                                    <li>Used JavaScript when developing page navigation, form validation, time and date stamps</li>
                                </ul>
                            </p>
                        </div> */}
            <div className="resume-item">
              <h4>Software Engineer</h4>
              <h5>2021 - Present</h5>
              <p>
                <em>HCL Sri Lanka</em>
              </p>
              <p>
                <ul>
                  <li>
                    Designed, developed, and maintained web applications using
                    PHP, .NET, and C#, ensuring high performance and
                    reliability.
                  </li>
                  <li>
                    Optimized database performance and ensured data integrity
                    using SQL queries, stored procedures, and triggers.
                  </li>
                  <li>
                    Led an L1.5 team, providing guidance and mentorship while
                    streamlining support processes.
                  </li>
                  <li>
                    Collaborated with cross-functional teams to implement new
                    features, resolve application issues, and ensure seamless
                    user experiences.
                  </li>
                  <li>
                    Supported applications and handled provisioning tasks in
                    collaboration with L2 and L1.5 teams to ensure smooth
                    operations and minimize downtime.
                  </li>
                  <li>
                    Managed batch jobs, ensuring timely execution and resolution
                    of errors or exceptions.
                  </li>
                  <li>
                    Resolved over 500+ service requests and addressed 200+
                    incidents (INCs), maintaining a high level of customer
                    satisfaction.
                  </li>
                  <li>
                    Developed and deployed scalable and secure back-end
                    solutions tailored to business requirements.
                  </li>
                  <li>
                    Provided technical support, user documentation, and training
                    to ensure effective application usage and understanding.
                  </li>
                </ul>
              </p>
            </div>
            {/* <div className="resume-item">
              <h4>web developer</h4>
              <h5>2021 - 2022</h5>
              <p>
                <em>Industrial Development Organization</em>
              </p>
              <p>
                <ul>
                  <li>
                    Implemented websites, landing pages and admin panels from
                    static mockups with responsive.
                  </li>
                  <li>
                    Used JavaScript when developing page navigation, form
                    validation, time and date stamps
                  </li>
                  <li>Used PHP as backend language and MySQL as database.</li>
                </ul>
              </p>
            </div> */}
            <div className="resume-item">
              <h4>Freelance web developer</h4>
              <h5>2019 - Present</h5>
              <p>
                <em>Eravur, Batticalo</em>
              </p>
              <p>
                <ul>
                  <li>
                    Delivered end-to-end software solutions for clients using
                    technologies such as PHP, Laravel, .NET, and React.
                  </li>
                  <li>
                    Built responsive web applications with modern UI/UX
                    practices using HTML, CSS, Bootstrap, and JavaScript.
                  </li>
                  <li>
                    Integrated AJAX and jQuery to enhance dynamic content
                    rendering and user experience.
                  </li>
                  <li>
                    Developed RESTful APIs and implemented back-end logic for
                    seamless client-server communication.
                  </li>
                  <li>
                    Maintained consistent project delivery timelines, ensuring
                    client satisfaction and repeat engagements.
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Resume;
